<script lang="ts">
	import type { DeviceLicense } from "@devices/api-client"
	import type { NewDeviceInputs } from "./TestStationController"

	interface Props {
		onsubmit: (properties: NewDeviceInputs) => void
	}

	let { onsubmit }: Props = $props()

	let license: DeviceLicense = $state()
	let automatic: boolean = $state(true)
	let newId: number = $state()

	$inspect(license, automatic, newId)

	const LISCENSE_TYPES: DeviceLicense[] = ["LUXPLAY", "LPS_CLASSIC", "COMMERCIAL_CLASSIC"]

	function submit() {
		if (automatic === true) return onsubmit({ automatic, license })
		else onsubmit({ automatic, id: newId, license })
	}
</script>

<h1>Device Options</h1>
<div class="select-container">
	<label for="license-input">License: </label>
	<select name="license_input" id="license-input" bind:value={license}>
		{#each LISCENSE_TYPES as type}
			<option value={type}>{type}</option>
		{/each}
	</select>
</div>
<br />
<div class="checkbox-container">
	<label for="auto-assign-input">Auto-Assign ID:</label>
	<input type="checkbox" name="auto_assign_input" id="auto-assign-input" bind:checked={automatic} />
</div>
{#if !automatic}
	<div class="input-container">
		<label for="id-input">ID: </label>
		<input type="number" id="id-input" name="id_input" bind:value={newId} />
	</div>
{/if}
<div class="button-container">
	<button onclick={submit}>Continue</button>
</div>

<style>
	h1 {
		font-size: 2rem;
	}

	.select-container,
	.input-container,
	.checkbox-container {
		display: flex;
		flex-direction: row;
		margin: 0;
		align-items: center;
	}

	input[type="checkbox"] {
		height: 1rem;
		width: 1rem;
		border-radius: 4px;
	}

	#id-input {
		width: 6rem;
	}

	label {
		cursor: default;
		margin-right: 0.5rem;
	}

	.button-container {
		position: absolute;
		bottom: 1rem;
		width: fit-content;
		right: 1rem;
	}
</style>
